import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/typography';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

const VideoPopup = ({ onClose, candidate }) => {
  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>
            Video <span className="font-semibold">{candidate.name}</span> is a <span className={cn("font-semibold", candidate.Resume_Score >= 80 ? "text-green-600" : candidate.Resume_Score >= 50 ? "text-yellow-600" : "text-orange-600")}>{candidate.Resume_Score >= 80 ? "Great Match" : candidate.Resume_Score >= 50 ? "Good Match" : "Basic Match"}</span>
          </DialogTitle>
        </DialogHeader>
        <video width="100%" height="auto" controls className="w-full rounded-lg">
          <source src="https://filesamples.com/samples/video/mp4/sample_640x360.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </DialogContent>
    </Dialog>
  );
};

export default VideoPopup;
